export { default as VictoryVoronoi } from "./victory-voronoi";
export { default as Voronoi } from "./voronoi";


//////////////////
// WEBPACK FOOTER
// ./~/victory-voronoi/es/index.js
// module id = 2504
// module chunks = 0